// Mirror of api/src/publica/creatives/creatives.service.ts → normalizePublicaFilename.
// Kept in sync so the file the admin downloads here matches what the main
// dashboard's link-creatives flow expects to find in Publica's library.
export function normalizePublicaFilename(name: string): string {
  return name.trim().replace(/[^a-zA-Z0-9._]/g, '_');
}
